module.exports = __webpack_public_path__ + "img/add_to_cart.f59daa95.svg";